import { mountRaceList } from './utils/mount-race-list.js';
import { STATE_URL } from './constants.js';
import { called_propositions } from './close_races.js';

mountRaceList('uncalled-ca-propositions', STATE_URL, {
  filter: {
    offices: ['I'],
    electionType: ['proposition'],
    sort: 'seat',
    excludeIds: called_propositions,
  },
  component: 'proposition',
  captionField: 'title',
}).catch(console.error);
